import React from 'react';
import { ArrowLeft } from 'lucide-react';

const TermsOfService: React.FC = () => {
    return (
        <div className="min-h-screen bg-background p-4 sm:p-8">
            <div className="max-w-3xl mx-auto">
                <a href="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6">
                    <ArrowLeft className="w-4 h-4" /> 返回登录
                </a>

                <h1 className="text-3xl font-bold text-foreground mb-6">服务条款</h1>
                <p className="text-muted-foreground mb-4">最后更新：2024年12月</p>

                <div className="prose prose-invert max-w-none space-y-6 text-foreground/90">
                    <section>
                        <h2 className="text-xl font-semibold mb-3">1. 服务说明</h2>
                        <p className="text-muted-foreground">
                            本系统是一个 WhatsApp 客服管理平台，用于管理和回复 WhatsApp 业务消息。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">2. 使用条款</h2>
                        <ul className="list-disc pl-6 space-y-2 text-muted-foreground">
                            <li>您必须遵守 WhatsApp 的商业政策和使用条款</li>
                            <li>不得使用本系统发送垃圾信息或骚扰用户</li>
                            <li>您需负责保护您的账户安全</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">3. 账户责任</h2>
                        <p className="text-muted-foreground">
                            您需对您账户下的所有活动负责。请妥善保管您的登录凭证。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">4. 服务变更</h2>
                        <p className="text-muted-foreground">
                            我们保留随时修改或终止服务的权利，恕不另行通知。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">5. 免责声明</h2>
                        <p className="text-muted-foreground">
                            本服务按"现状"提供。我们不对服务的可用性、准确性或可靠性作出任何保证。
                        </p>
                    </section>

                    <section>
                        <h2 className="text-xl font-semibold mb-3">6. 联系方式</h2>
                        <p className="text-muted-foreground">
                            如有任何问题，请联系系统管理员。
                        </p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
